import { cva } from '@/styled-system/css';

export const upsellLegalRecipe = cva({
  base: {
    'marginBlockStart': 'tighter',

    '& > .c11n_text': {
      color: 'inherit',
      textStyle: 'fineprint',
    },
    '& > .c11n_paragraph': {
      color: 'inherit',
      textStyle: 'fineprint',
    },
  },
  variants: {
    tone: {
      neutral: {
        color: 'text.subtle',
      },
      soft: {
        color: 'text.subtle',
      },
      hero: {
        color: 'Upsell.Legal.hero.text-legal',
      },
      impact: {
        color: 'text.onImpact.subtle',
      },
    },
  },
});
